"use strict"

import React from "react"

import { isLTPM } from "../../../../../components/shared_components_registration"

// Where we set distinctions for LTPM/LL versions of the component
const registration = {
  tag_name_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.tag" }) : "Tag Name"),
  search_match_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.search" }) : "Search Match"),
  search_text: (intl) => (isLTPM ? intl.formatMessage({ id: "general.search" }) : "Search"),
}

const observation_types = [
  "Readings",
  "MassBal",
  "PLNT_MassBal",
  "Metabolite",
  "Gas",
  "Gas_Traveler",
  "DRW",
  "Viability",
  "Scrubber",
  "Treatment",
  "Liquid",
  "Computed",
  "Analytics",
  "Site",
  "Distillation",
  "Unknown",
  "Summary",
]

export default function OptionLabel({ option = {}, intl, nameFn, showLoggingDetails = true }) {
  const refInfo = (option["observations"] || []).length > 0 ? option["observations"][0] : option
  const tag_name = refInfo.tag
  const option_label = nameFn(option)

  return (
    <>
      {option_label}
      {(observation_types.includes(option.category) || refInfo.smp_src) &&
        tag_name &&
        option_label !== tag_name && (
          <div style={{ fontSize: "75%", fontStyle: "italic" }}>
            <b>{registration.tag_name_label(intl)}</b>: {tag_name}
          </div>
        )}
      {option.matchExplanation && tag_name && option.matchExplanation !== tag_name && (
        <div style={{ fontSize: "75%", fontStyle: "italic" }}>
          <b>{registration.search_match_label(intl)}</b>: {option.matchExplanation}
        </div>
      )}
      {showLoggingDetails && (
        <>
          {Object.entries(option["dcs_logging_info"] || {}).map(([key, value], i) => {
            return (
              <div style={{ fontSize: "75%", fontStyle: "italic" }} key={`dcs_${i}`}>
                <b>{key}</b>: {Array.isArray(value) ? value.join(", ") : value}
              </div>
            )
          })}
        </>
      )}
    </>
  )
}
